<template>
  <b-modal
    :active="active"
    :can-cancel="canCancel"
    :trap-focus="true"
    :width="480"
    :close-button-aria-label="tier === 'force' ? '' : 'Close'"
    @close="onModalClose"
  >
    <div class="box">
      <h2 class="title is-5">{{ title }}</h2>
      <p class="mb-4" v-if="message">{{ message }}</p>
      <p class="mb-4" v-else-if="tier === 'force'">
        Your version of the QuickAdmit app is no longer supported. Please update to continue.
      </p>
      <p class="mb-4" v-else>
        A newer version of the QuickAdmit app is available. We recommend updating for the best
        experience.
      </p>
      <div class="buttons is-flex is-flex-wrap-wrap" style="gap: 0.5rem">
        <template v-if="platform === 'ios'">
          <b-button tag="a" :href="iosStoreUrl" target="_blank" rel="noopener noreferrer" type="is-primary">
            Update on the App Store
          </b-button>
        </template>
        <template v-else-if="platform === 'android'">
          <b-button
            tag="a"
            :href="androidStoreUrl"
            target="_blank"
            rel="noopener noreferrer"
            type="is-primary"
          >
            Update on Google Play
          </b-button>
        </template>
        <template v-else>
          <b-button tag="a" :href="iosStoreUrl" target="_blank" rel="noopener noreferrer" type="is-primary">
            App Store (iOS)
          </b-button>
          <b-button tag="a" :href="androidStoreUrl" target="_blank" rel="noopener noreferrer" type="is-primary">
            Google Play (Android)
          </b-button>
        </template>
        <b-button v-if="tier === 'suggest'" type="is-light" @click="$emit('later')">Later</b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'MobileAppUpdateModal',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    tier: {
      type: String,
      required: true,
      validator: (v) => v === 'force' || v === 'suggest',
    },
    platform: {
      type: String,
      default: 'unknown',
    },
    iosStoreUrl: {
      type: String,
      default: '',
    },
    androidStoreUrl: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
  },
  computed: {
    canCancel() {
      return this.tier === 'suggest';
    },
    title() {
      return this.tier === 'force' ? 'Update required' : 'Update available';
    },
  },
  methods: {
    onModalClose() {
      if (this.tier === 'suggest') {
        this.$emit('later');
      }
    },
  },
};
</script>
